import { getUserInfo } from 'Api/userApi'
import parse from 'date-fns/parse'

const formatAvatar = (avatar) => {
  const isBase64 = avatar && avatar.indexOf('data:') !== -1

  return isBase64
    ? null
    : 'temp/' + avatar.split('/temp/').pop()
}

/**
 * @param {string} birthday
 * @returns {string}
 */
const formatBirthday = (birthday) => {
  return (birthday !== null && birthday !== '')
    ? parse(birthday, 'yyyy-MM-dd', new Date()).toISOString()
    : null
}

/**
 * @param {UserAccount} model
 * @returns {Promise.<ApiUserAccountEdit>}
 */
export const formatUserAccountAsync = async (model) => {

  return {
    name: model.name,
    occupation: model.occupation,
    otherOccupation: model.otherOccupation,
    birthday: formatBirthday(model.birthday),
    photoPath: formatAvatar(model.avatar),
  }
}

export default {
  formatUserAccountAsync
}